import BaseProxy from '@/proxy/BaseProxy';

class PaymentProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('', parameters);
  }

  getRoboUrl(token, data) {
    this.headers = {
      'X-Id-Token': token,
    };
    this.setData(data);
    return this.submit('post', '/robokassa/url-payment/');
  }
}

export default PaymentProxy;



// WEBPACK FOOTER //
// ./src/proxy/PaymentProxy.js